import { render, staticRenderFns } from "./cherkInXq.vue?vue&type=template&id=a3331644&scoped=true"
import script from "./cherkInXq.vue?vue&type=script&lang=js"
export * from "./cherkInXq.vue?vue&type=script&lang=js"
import style0 from "./cherkInXq.vue?vue&type=style&index=0&id=a3331644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3331644",
  null
  
)

export default component.exports